module.exports = __webpack_public_path__ + "static/media/everyreel.4cf598e1.svg";